import { render, staticRenderFns } from "./APIRequests.vue?vue&type=template&id=bc5d6630&"
import script from "./APIRequests.vue?vue&type=script&lang=js&"
export * from "./APIRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports